import { render, staticRenderFns } from "./DeviceFeatureTags.vue?vue&type=template&id=20d30201&scoped=true"
import script from "./DeviceFeatureTags.vue?vue&type=script&lang=js"
export * from "./DeviceFeatureTags.vue?vue&type=script&lang=js"
import style0 from "./DeviceFeatureTags.vue?vue&type=style&index=0&id=20d30201&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d30201",
  null
  
)

export default component.exports